<label class="field-label" [attr.for]="for()">
  {{ text() }}
  @if (required()) {
    <span class="field-label__required" aria-hidden="true">*</span>
    <span class="visually-hidden">required</span>
  }
  @if (hint(); as h) {
    <span class="field-label__hint">{{ h }}</span>
  }
</label>
